// Shared chrome for the three email modals (template editor, send dialog, send history).
// Same visual vocabulary as AddSiteModal / FeasibilityCreateModal, factored out here
// because these three would otherwise redeclare it a third, fourth and fifth time.
import styled from "styled-components";

export const Backdrop = styled.div`
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1000;
  display: flex; align-items: center; justify-content: center;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 8px;
  width: ${(p) => (p.$wide ? "900px" : "760px")};
  max-width: 94vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #dee2e6;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212529;
`;

export const CloseBtn = styled.button`
  background: none; border: none;
  font-size: 18px; color: #6c757d;
  cursor: pointer; line-height: 1;
  &:hover { color: #212529; }
`;

export const Body = styled.div`
  padding: 14px 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px 16px;
  border-top: 1px solid #dee2e6;
`;

export const Btn = styled.button`
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid ${(p) => (p.$primary ? "#0d6efd" : "#ced4da")};
  background: ${(p) => (p.$primary ? "#0d6efd" : "#fff")};
  color: ${(p) => (p.$primary ? "#fff" : "#495057")};
  &:hover { filter: brightness(0.96); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const LangTabs = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  border-bottom: 1px solid #dee2e6;
`;

export const LangTab = styled.button`
  padding: 6px 14px;
  border: none;
  border-bottom: 2px solid ${(p) => (p.$active ? "#0d6efd" : "transparent")};
  background: none;
  color: ${(p) => (p.$active ? "#0d6efd" : "#6c757d")};
  font-size: 13px;
  font-weight: ${(p) => (p.$active ? 600 : 400)};
  cursor: pointer;
  &:hover { color: #0d6efd; }
`;

export const Loading = styled.div`
  padding: 40px 0;
  text-align: center;
  color: #adb5bd;
  font-size: 13px;
`;

export const Warning = styled.div`
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #fff8e1;
  border-left: 3px solid #fd7e14;
  font-size: 12px;
  color: #664d03;
  line-height: 1.5;
`;
